module.exports = __webpack_public_path__ + "img/ink_card_photo.30391e81.png";